const GUESS_USER = '/api/u?u=:u&type=:t';

export const USERLIST_UPDATED = 'admin/USERLIST_UPDATED';

//#admin
export const guessBy = (type, u) => {
  return (dispatch: Function) => {
    if (!u) {
      return dispatch({ type: USERLIST_UPDATED, data: { list: [] } });
    }
    fetch(GUESS_USER.replace(':u', u).replace(':t', type), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => dispatch({ type: USERLIST_UPDATED, data }));
  };
};

export default {
  guessBy
};



// WEBPACK FOOTER //
// ./src/actions/admin.actions.js